"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    pickDomainIDConfig: ()=>external_pick_config_js_namespaceObject.pickDomainIDConfig,
    pickMultiDomainIDConfig: ()=>external_pick_config_js_namespaceObject.pickMultiDomainIDConfig,
    logger: ()=>external_logger_js_namespaceObject.logger,
    relativeTime: ()=>external_time_ago_js_namespaceObject.relativeTime,
    mergeDomainIDConfig: ()=>external_pick_config_js_namespaceObject.mergeDomainIDConfig,
    ls: ()=>core_lib_namespaceObject.ls,
    generateEmptyDomainIDConfig: ()=>external_pick_config_js_namespaceObject.generateEmptyDomainIDConfig,
    sendCloudModalEvent: ()=>external_cloud_modal_event_js_namespaceObject.sendCloudModalEvent,
    timeAgo: ()=>external_time_ago_js_namespaceObject.timeAgo
});
const external_time_ago_js_namespaceObject = require("./time-ago.js");
const external_pick_config_js_namespaceObject = require("./pick-config.js");
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const external_logger_js_namespaceObject = require("./logger.js");
const external_cloud_modal_event_js_namespaceObject = require("./cloud-modal-event.js");
exports.generateEmptyDomainIDConfig = __webpack_exports__.generateEmptyDomainIDConfig;
exports.logger = __webpack_exports__.logger;
exports.ls = __webpack_exports__.ls;
exports.mergeDomainIDConfig = __webpack_exports__.mergeDomainIDConfig;
exports.pickDomainIDConfig = __webpack_exports__.pickDomainIDConfig;
exports.pickMultiDomainIDConfig = __webpack_exports__.pickMultiDomainIDConfig;
exports.relativeTime = __webpack_exports__.relativeTime;
exports.sendCloudModalEvent = __webpack_exports__.sendCloudModalEvent;
exports.timeAgo = __webpack_exports__.timeAgo;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "generateEmptyDomainIDConfig",
    "logger",
    "ls",
    "mergeDomainIDConfig",
    "pickDomainIDConfig",
    "pickMultiDomainIDConfig",
    "relativeTime",
    "sendCloudModalEvent",
    "timeAgo"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
